import React from 'react';
import Link from 'next/link';
import Head from 'next/head';

import { PAGE_BLOG, PAGE_BLOG_POST } from '@root/constants/routes';
import { BLOG_POSTS_PER_PAGE } from '@root/constants/blog';
import { BlogDownstreamProps, excerpt } from '@root/pages/wedding-ideas-blog';
import Card from 'components/Card';
import BlogPicture from 'components/Blog/Picture';
import IconArrowRight from 'components/IconArrowRight';
import NextSteps from 'components/NextSteps';
import SalesCalloutSwatches from 'components/SalesCalloutSwatches';
import SalesCalloutInspiration from 'components/SalesCalloutInspiration';
import IconArrowLeft from 'components/IconArrowLeft';
import LayoutBlog from 'layouts/Blog';

const BlogMore = ({ posts, page, totalPages, updatePage }: BlogDownstreamProps) => {
  const start = (page - 2) * BLOG_POSTS_PER_PAGE;
  const end = start + BLOG_POSTS_PER_PAGE;

  return (
    <>
      <Head>
        <title>Blog | Generation Tux</title>
      </Head>
      <div className="bg-gray-lighter py-1">
        <LayoutBlog>
          <section className="container lg:max-w-screen-md">
            <div className="row mb-64 gap-y-32">
              {posts.slice(start, end).map((post) => (
                <Card
                  key={post._id}
                  trackerClass={`tracker-callout-blog-post_${post.slug?.current.replace(/-/g, '_')}-210920-134950`}
                  ctaTitle="Read More"
                  href={PAGE_BLOG_POST}
                  as={`${PAGE_BLOG}/${post.slug?.current}`}
                  title={post.title ?? 'Title Missing'}
                  image={
                    <BlogPicture
                      slot="moreCard"
                      url={post.mainImage.asset.url!}
                      className="aspect-ratio-16by9"
                      alt={`${post.mainImage.alt}`}
                      crop
                      nativeWidth={post.mainImage.asset.metadata?.dimensions?.width!}
                    />
                  }
                  className="col-span-12 sm:col-span-6 lg:col-span-4"
                >
                  {excerpt(post)}
                </Card>
              ))}

              <div className="col-span-12 col-start-1 mt-80 flex">
                <div className="flex-grow">
                  {page === 1 ? (
                    <Link href={PAGE_BLOG} as={PAGE_BLOG}>
                      <div className="btn-info btn">
                        <IconArrowLeft /> {'Previous'}
                      </div>
                    </Link>
                  ) : (
                    <div className="btn-info btn" onClick={() => updatePage(page - 1)}>
                      <IconArrowLeft /> {'Previous'}
                    </div>
                  )}
                </div>
                <div className="text-sm">
                  Page {page} of {totalPages}
                </div>
                <div className="flex-grow text-right">
                  {page < totalPages && (
                    <div className="btn-info btn" onClick={() => updatePage(page + 1)}>
                      {'More Posts'} <IconArrowRight />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        </LayoutBlog>
      </div>

      <NextSteps
        ctaPageName="blog"
        salesCallout1={<SalesCalloutSwatches ctaPageName="blog" />}
        salesCallout2={<SalesCalloutInspiration ctaPageName="blog" />}
      />
    </>
  );
};

export default BlogMore;
